<template>
    <div class="pieChart">
        <p v-if="!onlyChart" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span class="flex_1">{{ title }}</span>
        </p>
        <img v-if="noData" class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
        <section v-else>
            <p v-if="!onlyChart" class="content fs14 mt12" v-html="content"></p>
            <section class="flex_box" :class="{ isDouble: isDouble }">
                <div class="chartBox" :id='chartId'></div>
                <div v-if="isDouble" class="chartBox" :id='chartIdRight'></div>
            </section>
        </section>
    </div>
</template>

<script>
import utils from "@/util/common";

const echarts = require('echarts');

export default {
    name: "PieCircleChart",
    props: {
        title: {
            type: String,
            default: '风险企业分布'
        },
        chartId: {
            type: String,
            default: 'pieCircleLeft'
        },
        chartIdRight: {
            type: String,
            default: 'pieCircleRight'
        },
        renderData: Object,
        isDouble: Boolean,
        onlyChart: Boolean,
        labelData: Array,
        timeData: String,
        entityType:{
            type: String,
            default: 'industry'
        },
    },
    data() {
        return {
            content: '',
            chart: null,
            colorData: [
                [ '#386ccf', '#afc4ec', ],
                [ '#f29e01', '#fbe1b2', ]
            ],
            noData: false,
        }
    },
    mounted() {
        if(this.isDouble) {
            let { target1, target2 } = this.renderData;
            if(!target1.total && !target2.total) {
                this.noData = true
                return
            }
            this.noData = false
            let data1 = [
                { name: '低于75分', count: target1.section1, value: utils.formatPercent(target1.section1, target1.total) },
                { name: '高于75分', count: target1.section2, value: utils.formatPercent(target1.section2, target1.total) },
            ]
            let data2 = [
                { name: '低于75分', count: target2.section1, value: utils.formatPercent(target2.section1, target2.total) },
                { name: '高于75分', count: target2.section2, value: utils.formatPercent(target2.section2, target2.total) },
            ]
            this.setContent([data1[0], data2[0]])
            this.renderFunc(data1, 0)
            this.renderFunc(data2, 1, this.chartIdRight)
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        setContent(data) {
            this.labelData.forEach((item, index) => {
                this.content += `<p>${ item + '：' + this.timeData }，${this.entityType == "company" ? "本企业舆情健康指数低于75分的下属机构共" :"本行业舆情健康指数低于75分的企业共"}${ data[index].count }家，占比${ data[index].value }%。</p>`
            })

        },
        renderFunc(useData, index, chartId = this.chartId) {
            let colorData = this.colorData[index]
            let labelStr = this.labelData[index]


            let chart = echarts.init(document.getElementById(chartId));
            let option = {
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['65%', '80%'],
                        avoidLabelOverlap: false,
                        labelLine: {
                            show: false
                        },
                        center: ['50%', '50%'],
                        borderWidth: 12,
                        color: colorData,
                        itemStyle : {
                            normal : {
                                fontSize: 12,
                                borderWidth: 2,
                                borderColor: '#FFFFFF',
                                label: {
                                    show: true,
                                    position: 'center',
                                    formatter: function (params) {
                                        if(params.name.indexOf('低于75分') > -1) {
                                            return "{a|" + labelStr + "}\n{b|低于}{bold|75}{b|分的风险企业}\n{bold|"
                                                + params.data.count + "}{b|家 占比}{bold|" + params.value + "}{b|%}"
                                        }
                                        else {
                                            return ''
                                        }
                                    },
                                    color: '#000000',
                                    fontSize: 12,
                                    rich: {
                                        a: {
                                            fontSize: 16,
                                            color: '#666666',
                                            paddingBottom: 6,
                                            lineHeight: 32,
                                        },
                                        b: {
                                            fontSize: 10,
                                            color: '#666666',
                                            lineHeight: 16,
                                        },
                                        bold: {
                                            fontSize: 10,
                                            color: '#666666',
                                            lineHeight: 16,
                                            fontWeight: 'bold',
                                        }
                                    }
                                },
                            },
                        },
                        data: useData,
                    }
                ]
            };
            chart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.pieChart {
    padding: 20px 16px;
    background-color: #FFFFFF;
    .isDouble {
        > div {
            width: 50%;
        }
    }
}
</style>